import useIsDesktop from "@hooks/useIsDesktop"

import { TabStack } from "@molecules/index"

import { ViewBarPhasesProps } from "./ViewBarPhases.types"

export default function ViewBarPhases(props: ViewBarPhasesProps) {
    const { children } = props
    const isDesktop = useIsDesktop()

    if (isDesktop) {
        return (
            <TabStack variant="contained" size="lg">
                {children}
            </TabStack>
        )
    } else {
        return null
    }
}
